import * as a from "./action";
import { OPEN_ERROR_BOX } from "../../constants/actionTypes";
import { LOADING_EMUNS } from "./constants";
import { setResetData } from "../../modules/MagSensor";
import { doRemoveErrorCard } from "../SSUploader";

const validate = (value, rule) => {
  let match = false;

  if (rule === NaN) {
    match = true;
  }

  if (value.length === rule) {
    match = true;
  }

  return match;
};

export const validateNumOrPin = (
  field,
  value,
  rules,
  ruleIdx,
  required = false
) => {
  if (required && !value.length) {
    return { error: true, msg: `${field} is required.` };
  }

  const successful = {
    error: false,
    msg: "",
  };

  if (rules.split(", ").some((v) => v.split(":")[ruleIdx].trim() == "null")) {
    return successful;
  }

  let match = false;

  rules.split(", ").forEach((v) => {
    if (validate(value, Number(v.split(":")[ruleIdx].trim()))) {
      match = true;
    }
  });

  if (!match) {
    return {
      error: true,
      msg: `${field} does not match the character required length.`,
    };
  }

  return successful;
};

export const createCart =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const createCart = await remote(
        "post",
        `/v3/carts`,
        { action: "sell" },
        "createCart",
        dispatch
      );

      if (createCart.message) {
        throw createCart;
      }

      dispatch(a.setCartID(createCart.cartId));
      dispatch(a.setCartCards(createCart.cards));
    } catch (error) {
      dispatch({ type: OPEN_ERROR_BOX, payload: error });
    }
  };

export const addCard =
  (idx, myCard) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(a.setLoadingState(idx, LOADING_EMUNS.LOADING));

      const cartSell = await remote(
        "post",
        `/v3/carts/${getState().Cart.cart.id}/cards`,
        myCard,
        "sending a card to a cart",
        dispatch
      );

      if (cartSell.message) {
        throw cartSell;
      }

      dispatch(setResetData());
      dispatch(a.setLoadingState(idx, LOADING_EMUNS.LOADED));
      dispatch(a.setAddCardError({}));
      dispatch(a.setCartCards(cartSell.cards.reverse()));
      if (idx.includes("spreadsheet")) {
        dispatch(doRemoveErrorCard(idx));
      }
    } catch (error) {
      dispatch(a.setLoadingState(idx, LOADING_EMUNS.ERROR));
      dispatch(a.setAddCardError({ id: idx, msg: error.message[0] }));
    }
  };

export const getCart =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const getCart = await remote("get", `/v3/carts`, {}, "getCart", dispatch);

      if (getCart.message) {
        throw getCart;
      }

      dispatch(a.setCartID(getCart.cart.sellCart.cartId));
      dispatch(a.setCartCards(getCart.cart.sellCart.cards.reverse()));
    } catch (error) {
      dispatch({ type: OPEN_ERROR_BOX, payload: error });
    }
  };

export const removeCard =
  (cardID) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const deleteCardInCart = await remote(
        "delete",
        `v3/carts/${getState().Cart.cart.id}/cards/${cardID}`,
        {},
        "deleting a card from the cart",
        dispatch
      );

      if (deleteCardInCart?.message) {
        throw deleteCardInCart;
      }

      await dispatch(getCart());
    } catch (e) {
      dispatch({ type: OPEN_ERROR_BOX, payload: e });
    }
  };

export const updateCard =
  (card, id) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      dispatch(a.setLoadingState(id, LOADING_EMUNS.LOADING));

      const cart = await remote(
        "put",
        `v3/carts/${getState().Cart.cart.id}/cards/${id}`,
        card,
        "updating the card",
        dispatch
      );

      if (cart.message) {
        throw cart;
      }

      dispatch(a.setLoadingState(id, LOADING_EMUNS.LOADED));
      dispatch(a.setUpdateCardError(""));
      dispatch(a.setCartCards(cart.cards.reverse()));
    } catch (e) {
      dispatch(a.setLoadingState(id, LOADING_EMUNS.ERROR));
      dispatch(a.setUpdateCardError(e.message));
    }
  };

export const clearCart =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const cart = await remote(
        "delete",
        `v3/carts/${getState().Cart.cart.id}/cards/`,
        {},
        "deleting all card from the cart",
        dispatch
      );

      if (cart !== " ") {
        dispatch(a.setCartCards([]));
      } else {
        throw cart;
      }
    } catch (e) {
      dispatch({ type: OPEN_ERROR_BOX, payload: e });
    }
  };
